import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './components/AuthContext';
import { Provider } from 'react-redux';
import { store } from './store/store';


if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((reg) => console.log("SW registered", reg))
      .catch((err) => console.log("SW registration failed:", err));
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  <Router>
    <React.StrictMode>
      <AuthProvider>
      <Provider store={store}>
        <App />
        </Provider>
      </AuthProvider>
    </React.StrictMode>
  </Router>


);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
